var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submenu"},[_c('el-row',[_c('el-col',{attrs:{"span":8}},[_c('span',{staticStyle:{"color":"#606266"}},[_vm._v("欢迎您，"+_vm._s(_vm.user.message)+"["+_vm._s(_vm.user.result)+"]")]),_vm._v(" "),_c('el-link',{staticStyle:{"margin-right":"30px"},attrs:{"underline":false},on:{"click":_vm.exit}},[_vm._v("退出登录")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02166197","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/navcon.vue
// module id = null
// module chunks = 